{
  "title": "السماح بالوصول إلى موقعك؟",
  "body": "بالسماح بالوصول إلى موقعك، يمكننا التأكد من وصولك إلى المنشأة لتسجيل الدخول",
  "disagree": "رفض",
  "agree": "موافقة"
}
